import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CircleGlyph = /*#__PURE__*/createElement("g", {
  id: "circle"
}, /*#__PURE__*/createElement("path", {
  d: "M42,21.75A20.25,20.25,0,1,0,62.25,42,20.27,20.27,0,0,0,42,21.75Z"
}));
const Circle = createSvg({
  name: 'circle',
  path: CircleGlyph
});

export default Circle;
export { CircleGlyph };
